// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"39f2ae99","29":"7fe88fe9","36":"6e57767b","61":"71b245a8","68":"5c4fc21f","194":"289d5b73","251":"df9ab713","378":"155915cd","453":"41435cd6","570":"ed3334fa","701":"b088a558","727":"884b43b4","849":"70a1034f","931":"8e9cdf68","994":"68140197"}[chunkId] + ".chunk.js";
};